import { AccountHeartIcon } from './AccountHeartIcon';

/**
 * author: Michael Irigoyen
 * id 15C54239-5327-4962-95CD-721512C6B27F
 * name account-heart
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-heart.svg
 * tags
 * - Account / User 
 * - Medical / Hospital 
 */
export const UserHeartIcon = AccountHeartIcon;
export default UserHeartIcon